import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './components/footer/footer.component';
import { LogoComponent } from './components/logo/logo.component';
import { LogoNameHorizontalComponent } from './components/logo-name-horizontal/logo-name-horizontal.component';
import { LogoNameVerticalComponent } from './components/logo-name-vertical/logo-name-vertical.component';
import { TableHeadCellAllignmentDirective } from './directives/table-head-cell-alignment';
import { MaterialModule } from './material/material.module';
import { BtnWrapModule } from './modules/btn-wrap/btn-wrap.module';
import { CodeInputWrapModule } from './modules/code-input-wrap/code-input-wrap.component';
import { CountryModule } from './modules/country/country.module';
import { CurrencyModule } from './modules/currency/currency.module';
import { DataViewModule } from './modules/data-view/data-view.module';
import { ImgViewModule } from './modules/img-view/img-view.component';
import { InputClearBtnModule } from './modules/input-clear-btn/input-clear-btn.module';
import { InputErrorModule } from './modules/input-error/input-error.module';
import { LangModule } from './modules/lang/lang.module';
import { MatFormFieldWrapModule } from './modules/mat-form-field-wrap/mat-form-field-wrap.module';
import { PhoneModule } from './modules/phone/phone.module';
import { SelectedDocsModule } from './modules/selected-docs/selected-docs.module';
import { IbSnackbarModule } from './modules/snackbar/snackbar.component';
import { IbSpinnerModule } from './modules/spinner/spinner.module';
import { TableCellContentModule } from './modules/table-cell-content/table-cell-content.component';
import { TimeDiffModule } from './modules/time-diff/time-diff.module';
import { TooltipModule } from './modules/tooltip/tooltip.module';
import { UploadModule } from './modules/upload/upload.module';
import { UserIdleModule } from './modules/user-idle/user-idle.component';
import { IbWebcamModule } from './modules/webcam/webcam.module';
import { TranslocoRootModule } from './transloco-root';

const modules = [
  // core
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,

  // material
  MaterialModule,

  // translate
  TranslocoRootModule,

  // 3rd patry - preferable to import to 3rd party component module

  // app elements
  PhoneModule,
  CountryModule,
  CurrencyModule,
  InputErrorModule,
  InputClearBtnModule,
  TooltipModule,
  UploadModule,
  SelectedDocsModule,
  LangModule,
  IbWebcamModule,
  MatFormFieldWrapModule,
  TimeDiffModule,
  CodeInputWrapModule,
  IbSpinnerModule,
  BtnWrapModule,
  DataViewModule,
  TableCellContentModule,
  IbSnackbarModule,
  UserIdleModule,
  ImgViewModule,
];

// todo move to modules
const components = [
  LogoNameVerticalComponent,
  LogoComponent,
  LogoNameHorizontalComponent,
  FooterComponent,
];

const directives = [TableHeadCellAllignmentDirective];

@NgModule({
  imports: [...modules],
  declarations: [...components, ...directives],
  exports: [...modules, ...components, ...directives],
})
export class SharedModule {}
